import React, { useState, useCallback, useRef } from 'react';
import { Icon } from '@ann/web-components';
import { Wrapper, TooltipBubble } from './CopyableContactItem.styled';

const COPY_FEEDBACK_MS = 1500;

const CopyableContactItem = ({ iconName, value }) => {
  const [copied, setCopied] = useState(false);
  const resetTimerRef = useRef(null);

  const handleCopy = useCallback(
    (e) => {
      e.stopPropagation();
      navigator.clipboard.writeText(value).catch(() => {});

      setCopied(true);

      if (resetTimerRef.current) clearTimeout(resetTimerRef.current);
      resetTimerRef.current = setTimeout(() => {
        setCopied(false);
        resetTimerRef.current = null;
      }, COPY_FEEDBACK_MS);
    },
    [value]
  );

  return (
    <Wrapper type="button" onClick={handleCopy} aria-label={`Copy ${value}`}>
      <Icon name={iconName} width="14px" height="14px" />
      <TooltipBubble $forceVisible={copied}>
        {copied ? 'Copied!' : value}
      </TooltipBubble>
    </Wrapper>
  );
};

export default CopyableContactItem;
